import React from 'react';
import { ClientNameAndAvatar } from '@/components/table/ClientNameAndAvatar';
import { paths } from '@/app/routes';
import { firstTwoCapsOrNumbers } from '@/utils/constants';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Tooltip, useTheme } from '@mui/material';

const PolicyClientCell = ({
	ClientDocId: clientId,
	ClientName,
	width,
	showContact = true,
}) => {
	const theme = useTheme();

	const clientLink = clientId ? `${paths.clients}/${clientId}` : '';

	const avatar = (
		<ClientNameAndAvatar
			title={ClientName}
			initials={firstTwoCapsOrNumbers(ClientName)}
			width={width ?? 300}
			{...(clientLink && {
				colour: showContact ? theme.palette.primary.main : 'inherit',
			})}
			{...(!showContact &&
				clientLink && {
				sx: {
					'&:hover': { color: theme.palette.primary.main },
				},
			})}
		/>
	);

	if (!clientLink) {
		return (
			<Tooltip title='Client does not exist in Folio' placement='right'>
				<div style={{ height: '100%', width: '100%', alignContent: 'center' }}>{avatar}</div>
			</Tooltip>
		);
	}

	return (
		<Link
			to={clientLink}
			variant='subtitle2'
			component={RouterLink}
			onClick={(e) => e.stopPropagation()}
			sx={{
				textDecorationLine: 'none',
				width: '100%',
				...(!showContact && {
					color: 'inherit',
					'&:hover': { color: theme.palette.primary.main },
				}),
			}}
		>
			{avatar}
		</Link>
	);
};

export default PolicyClientCell;
